export default __webpack_public_path__ + "static/2-e2596ebc03130263219c3f615b0e30a9.png";